const avalonaeBlockSelector =
  '[id^="shopify-block-"][id*="avalonae_reviews_video_carousel"], [id^="shopify-block-"][id*="avalonae_reviews_ugc_gallery"]';

const activeAvalonaeBlocks = new WeakSet();
const observedAvalonaeBlocks = new WeakSet();

function getAvalonaePreviewVideos(block) {
  if (block.id.includes('avalonae_reviews_video_carousel')) {
    return block.querySelectorAll('[class*="avr-vc-tm-"] video');
  }

  return block.querySelectorAll('[id^="ug-tk-"] video:not(.ug-tv)');
}

function showAvalonaePreviewFrame(video) {
  if (video.dataset.lumaauraPreviewState || !video.currentSrc && !video.src) return;

  video.dataset.lumaauraPreviewState = 'loading';
  video.muted = true;
  video.playsInline = true;

  const markReady = () => {
    video.dataset.lumaauraPreviewState = 'ready';
  };

  const seekToPreview = () => {
    if (!video.paused) {
      markReady();
      return;
    }

    const duration = Number.isFinite(video.duration) ? video.duration : 0;
    const previewTime = duration > 0 ? Math.min(0.08, Math.max(0.01, duration - 0.01)) : 0.08;

    video.addEventListener('seeked', markReady, { once: true });

    try {
      video.currentTime = previewTime;
    } catch {
      markReady();
    }
  };

  if (video.readyState >= HTMLMediaElement.HAVE_METADATA) {
    seekToPreview();
  } else {
    video.addEventListener('loadedmetadata', seekToPreview, { once: true });
    if (video.preload === 'none') video.preload = 'metadata';
    video.load();
  }

  window.setTimeout(markReady, 2500);
}

function prepareAvalonaeBlock(block) {
  getAvalonaePreviewVideos(block).forEach(showAvalonaePreviewFrame);
}

const avalonaeBlockObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        activeAvalonaeBlocks.add(entry.target);
        prepareAvalonaeBlock(entry.target);
      } else {
        activeAvalonaeBlocks.delete(entry.target);
      }
    });
  },
  { rootMargin: '500px 0px' }
);

function observeAvalonaeBlock(block) {
  if (observedAvalonaeBlocks.has(block)) return;
  observedAvalonaeBlocks.add(block);
  avalonaeBlockObserver.observe(block);
}

function discoverAvalonaeBlocks(scope) {
  if (scope instanceof Element && scope.matches(avalonaeBlockSelector)) {
    observeAvalonaeBlock(scope);
  }

  scope.querySelectorAll?.(avalonaeBlockSelector).forEach(observeAvalonaeBlock);

  const parentBlock = scope instanceof Element ? scope.closest(avalonaeBlockSelector) : null;
  if (parentBlock && activeAvalonaeBlocks.has(parentBlock)) prepareAvalonaeBlock(parentBlock);
}

discoverAvalonaeBlocks(document);

const avalonaeMutationObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) discoverAvalonaeBlocks(node);
    });
  });
});

avalonaeMutationObserver.observe(document.body, { childList: true, subtree: true });
